import Tooltip from 'primevue/tooltip'
import type { App } from 'vue'

export const installPrimeTools = (app: App) => {
    app.directive('tooltip', Tooltip)
}

export const getThemeConfig = (preset: ANY) => {
    return {
        preset,
        options: {
            darkModeSelector: 'dark-mode',
        },
    }
}
